import RunEvaluation from '@/features/runEvaluation/components/RunEvaluationDialog';

import ApplicationDetailsFields from './ApplicationDetailsFields';
import ApplicationDetailsGrid from './ApplicationDetailsGrid';
import ApplicationDetailsHeader from './ApplicationDetailsHeader';
import ApplicationDetailsMobileList from './ApplicationDetailsMobileList';
import ApplicationDetailsMobilePanel from './ApplicationDetailsMobilePanel';
import ApplicationDetailsToolbar from './ApplicationDetailsToolbar';
import ApplicationDetailsTrend from './ApplicationDetailsTrend';
import { useApplicationDetailsController } from './useApplicationDetailsController';

import './ApplicationDetailsPage.css';

const ApplicationDetails = () => {
  const {
    desktopTrendProps,
    fieldsProps,
    gridProps,
    headerProps,
    isMobileViewport,
    mobileListProps,
    mobilePanelProps,
    runEvaluationProps,
    toolbarProps,
  } = useApplicationDetailsController();

  return (
    <>
      <div className="flex flex-col lg:flex-row h-full max-sm:h-auto w-full gap-x-6 gap-y-4">
        <div className="lg:h-full flex flex-col gap-4 lg:gap-12 w-full lg:w-[350px] lg:border-r border-gray-200">
          <ApplicationDetailsHeader {...headerProps} />
          {!isMobileViewport ? (
            <ApplicationDetailsFields {...fieldsProps} />
          ) : null}
          <ApplicationDetailsTrend {...desktopTrendProps} />
        </div>
        <div className="relative h-full max-sm:h-auto flex flex-col gap-4 max-sm:w-full sm:flex-1">
          {!isMobileViewport ? (
            <ApplicationDetailsToolbar {...toolbarProps} />
          ) : null}
          {isMobileViewport ? (
            <div className="application-details-cards-container w-full pr-1">
              <ApplicationDetailsMobileList {...mobileListProps} />
            </div>
          ) : (
            <ApplicationDetailsGrid {...gridProps} />
          )}
        </div>
        <ApplicationDetailsMobilePanel {...mobilePanelProps} />
        <RunEvaluation {...runEvaluationProps} />
      </div>
    </>
  );
};

export default ApplicationDetails;
